export default function settingsKeyPrefix() {
    let res = '';

    // if no gd object initialized yet
    // @ts-ignore
    if (!window.gd) return '';

    switch (gd.viewMode) {
        case 'shared-view': res = 'shared-view.';
    }

    return res;
}
